export const REACT_SCRIPT_URL = 'https://unpkg.com/react@17/umd/react.production.min.js';
export const REACT_DOM_SCRIPT_URL = 'https://unpkg.com/react-dom@17/umd/react-dom.production.min.js';
export const EMBEDDED_EXPLORER_SCRIPT_URL = process.env.REACT_APP_EMBEDDED_EXPLORER_SCRIPT_URL;
export const EMBEDDED_EXPLORER_US_PARCEL_LAYER_NAME = 'US Parcels';
/**
 * Default view for Embedded Explorer
 */
export const EMBEDDED_EXPLORER_INITIAL_VIEW = {
  lonLat: {
    lat: 37.0902,
    lon: -95.7129,
  },
  zoom: 3,
};
/**
 * Default configuration for Embedded Explorer
 */
export const EMBEDDED_EXPLORER_DEFAULTS = {
  // Add default options here as needed
  view: EMBEDDED_EXPLORER_INITIAL_VIEW,
  measurementPanelEnabled: false,
  searchBarEnabled: false,
  showToastMessages: false,
  sidebarEnabled: false,
  timelineEnabled: false,
  toolsPanelEnabled: false,
};

Object.freeze(EMBEDDED_EXPLORER_DEFAULTS);
Object.freeze(EMBEDDED_EXPLORER_DEFAULTS.center);
